export enum ScreenSize {
  xxs = 480,
  xs = 575,
  sm = 576,
  md = 768,
  xl = 1200,
  xxl = 1400,
}
